module.exports = __webpack_public_path__ + "static/media/Bingo Logo.8ea48acc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/mockAPI/images/Bingo Logo.jpg
// module id = 261
// module chunks = 0